import { render, staticRenderFns } from "./PolicyTable.vue?vue&type=template&id=b30437e0"
import script from "./PolicyTable.vue?vue&type=script&lang=js"
export * from "./PolicyTable.vue?vue&type=script&lang=js"
import style0 from "./PolicyTable.vue?vue&type=style&index=0&id=b30437e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports